import { Footer, FooterButtons } from '@/design_system/Footer';
import { useArticleOngoingShipment } from '@/models/shipment';
import { canActOnBehalfOfNonDigitalizedWorkshop, hasPermission } from '@/models/user';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import { useCurrentSession } from '@/services/auth';

import { CreateShipmentButton } from './shared/CreateShipmentButton';
import { ValidateTransitFromToNonDigitalizedWorkshopButton } from './shared/ValidateTransitFromToNonDigitalizedWorkshopButton';
import { ArticleActionProps } from './ArticleActions';

export const TransitFromNonDigitalizedWorkshopToStoreAction = ({
  article,
  onActionDone,
}: ArticleActionProps) => {
  const { request, workflow } = useRequestContext();
  const { currentSession } = useCurrentSession();
  const { shipment, isLoading } = useArticleOngoingShipment(article);

  const canActOnBehalfOfWorkshop = canActOnBehalfOfNonDigitalizedWorkshop({
    user: currentSession,
    request,
    workflow,
  });

  const canVerifyReceptionOnStore = hasPermission(currentSession, 'verify_shipment_reception', {
    entityId: request.storeId,
  });

  if (isLoading || shipment) {
    return null;
  }

  return (
    <Footer>
      <FooterButtons>
        {canActOnBehalfOfWorkshop && (
          <CreateShipmentButton variant={canVerifyReceptionOnStore ? 'secondary' : 'primary'} />
        )}
        {canVerifyReceptionOnStore && (
          <ValidateTransitFromToNonDigitalizedWorkshopButton onActionDone={onActionDone} />
        )}
      </FooterButtons>
    </Footer>
  );
};
